// ============================================
// INFRASTRUCTURE - Consulta Boleta Repository (público, sin JWT)
// ============================================

import { axiosClient } from './axios-client';

export type TipoConsultaBoleta = 'BOLETA' | 'VOUCHER';

export interface ConsultaBoletaPublicaPayload {
  rut: string;
  tipo: TipoConsultaBoleta;
  numero: number;
  /** Honeypot: campo invisible para personas, debe viajar vacío. */
  website: string;
}

export interface ConsultaBoletaPublicaDetalle {
  nombreProducto: string;
  cantidad: number;
  precioUnitario: number;
  /** Monto de la línea neto de descuento (el cobrado y el que va al DTE). */
  total: number;
  /** Descuento de la línea en CLP. */
  descuento?: number;
  /** Monto de la línea a precio de lista, antes del descuento. */
  subtotalSinDescuento?: number;
}

export interface ConsultaBoletaPublicaResult {
  boletaId: number;
  electronicReceipt: boolean;
  siiDteEmitidoId: number | null;
  siiFolio: number | null;
  contribuyenteRazonSocial: string | null;
  contribuyenteGiro: string | null;
  rut: string;
  nombreAlmacen: string;
  direccionAlmacen: string;
  numeroLocal: string | null;
  logoUrl: string | null;
  fecha: string;
  details: ConsultaBoletaPublicaDetalle[];
  iva: number;
  descuento: number;
  /** Suma de los montos de línea a precio de lista, antes de descuentos. */
  subtotalSinDescuento?: number;
  total: number;
}

export const consultaBoletaRepository = {
  async consultar(payload: ConsultaBoletaPublicaPayload): Promise<ConsultaBoletaPublicaResult> {
    const { data } = await axiosClient.post<ConsultaBoletaPublicaResult>(
      '/public/boletas/consulta',
      payload
    );
    return data;
  },
};
